import React from 'react';
import { Users } from 'lucide-react';
import { actionItems } from '../../utils/constants';

const Decisions = () => (
  <div className="space-y-8">
    <div className="flex items-center justify-between">
      <h2 className="text-3xl font-bold text-gray-900">Board Decisions Required</h2>
      <div className="text-sm text-gray-500">1 Action Item</div>
    </div>
    
    <div className="space-y-6">
      {actionItems.map((item, index) => (
        <div key={index} className="bg-white p-8 rounded-xl border shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between mb-6">
            <div className="flex-1">
              <div className="flex items-center space-x-3 mb-3">
                <div className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${
                  item.priority === 'high' 
                    ? 'bg-red-100 text-red-800 border border-red-200' 
                    : 'bg-amber-100 text-amber-800 border border-amber-200'
                }`}>
                  {item.priority} Priority
                </div>
                <span className="text-sm text-gray-500 font-medium">Due: {item.deadline}</span>
                <span className="text-sm font-semibold text-green-600">{item.amount}</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{item.item}</h3>
              <p className="text-gray-600 mb-3">{item.description}</p>
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <Users className="w-4 h-4" />
                <span>Owner: {item.owner}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Decisions;